import { platform } from '@/utils/platform';

/**
 * Check if native Google Auth is available via @capgo/capacitor-social-login.
 */
export function isNativeGoogleAuthAvailable(): boolean {
  return platform.isNative && platform.isPluginAvailable('SocialLogin');
}

export async function initNativeGoogleAuth(webClientId: string, iOSClientId?: string) {
  if (!isNativeGoogleAuthAvailable()) return;

  try {
    const { SocialLogin } = await import('@capgo/capacitor-social-login');
    await SocialLogin.initialize({
      google: {
        webClientId,
        ...(platform.isIOS ? {
          iOSClientId: iOSClientId || webClientId,
          // iOSServerClientId ensures the ID token audience matches the web client ID,
          // so the backend can verify tokens from both web and native flows
          iOSServerClientId: webClientId,
        } : {}),
        mode: 'online',
      },
    });
    console.log('[GoogleAuth] Initialized via @capgo/capacitor-social-login');
  } catch (err) {
    console.warn('[GoogleAuth] Init failed:', err);
  }
}

export async function nativeGoogleSignIn(): Promise<string> {
  const { SocialLogin } = await import('@capgo/capacitor-social-login');
  const res = await SocialLogin.login({
    provider: 'google',
    options: {
      scopes: ['email', 'profile'],
    },
  });

  if (res.result.responseType === 'online') {
    const idToken = res.result.idToken;
    if (!idToken) {
      throw new Error('No id_token received from Google Sign-In');
    }
    return idToken;
  }

  throw new Error('Unexpected offline response from Google Sign-In');
}
